import React, { ChangeEventHandler, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { addKey } from "../config/functions"
import { RouteMasterType } from "../redux/actions/routeMasterActions"
import { addStopMaster, fetchStopMaster, StopMasterType, updateStopMaster } from "../redux/actions/stopMasterActions"
import { Key } from "../redux/actions/types"
import { StoreState } from "../redux/reducers"
import { AppDispatch } from "../redux/store"
import { FormInput } from "./custom/components"
import Option from "./Option"
import { ToastTypes, useToast } from "./toast/ToastProvider"
import { FormType, FormTypeList } from "./types"

interface Props {
    formType: FormType
    editData?: StopMasterType
    onSave: () => void
}

const StopMasterForm = ({ formType, onSave, editData }: Props) => {
    const toast = useToast()

    const dispatch = useDispatch<AppDispatch>()
    const routeMaster = useSelector<StoreState, Array<RouteMasterType & Key>>(state => addKey(state.routeMaster))

    const [number, setNumber] = useState<string>('')
    const [numberError, setNumberError] = useState<string>('')
    const [name, setName] = useState<string>('')
    const [nameError, setNameError] = useState<string>('')
    const [routeName, setRouteName] = useState<string>('')
    const [routeId, setRouteId] = useState<string>('')
    const [routeIdError, setRouteIdError] = useState<string>('')

    const resetStates = () => {
        setNumber('')
        setNumberError('')
        setName('')
        setNameError('')
        setRouteName('')
        setRouteId('')
        setRouteIdError('')
    }

    const handleNumber: ChangeEventHandler<HTMLInputElement> = (e) => {
        setNumber(e.target.value)
        setNumberError('')
    }

    const handleName: ChangeEventHandler<HTMLInputElement> = (e) => {
        setName(e.target.value)
        setNameError('')
    }

    const handleRouteId: ChangeEventHandler<HTMLInputElement> = (e) => {
        setRouteId(e.target.value)
        const index = routeMaster.findIndex(rm => rm.id !== undefined && rm.id.toString() === e.target.value)

        if (index > -1) {
            setRouteName(routeMaster[index].name)
        }

        setRouteIdError('')
    }

    const handleClear = () => {
        resetStates()
    }

    const handleSave = () => {
        let error = false
        const data: StopMasterType = {
            routeId: parseInt(routeId),
            routeName: routeName,
            name: name,
            number: number
        }

        if (data.number === "") {
            setNumberError('Stop Number required')
            error = true
        } else if (parseInt(data.number) <= 0) {
            setNumberError('Invalid Stop Number')
            error = true
        }

        if (data.name === "") {
            setNameError('Stop Name required')
            error = true
        } else if ((data.name).length > 30) {
            setNameError('Stop Name must be within 30 characters')
            error = true
        }

        if (isNaN(data.routeId)) {
            setRouteIdError('Route required')
            error = true
        } else if (data.routeId <= 0) {
            setRouteIdError('Invalid Route')
            error = true
        }


        if (!error) {
            if (formType === FormTypeList.ADD) {

                dispatch(addStopMaster(data)).then(text => {
                    toast(text)
                    onSave()
                    dispatch(fetchStopMaster())
                }).catch(text => {
                    toast(text, ToastTypes.ERROR)
                })
            } else if (formType === FormTypeList.UPDATE && editData !== undefined && editData.id !== undefined) {
                dispatch(updateStopMaster(data, editData.id)).then(text => {
                    toast(text)
                    onSave()
                    dispatch(fetchStopMaster())
                }).catch(text => {
                    toast(text, ToastTypes.ERROR)
                })
            }
        }
    }

    useEffect(() => {
        if (formType === FormTypeList.UPDATE && editData !== undefined) {

            setNumber(editData.number)
            setName(editData.name)
            setRouteName(editData.routeName !== undefined ? editData.routeName : '')
            setRouteId(editData.routeId !== undefined ? editData.routeId.toString() : '')

        } else {
            resetStates()
        }
    }, [formType, editData])


    return <div className='container'>
        <div className="row">

            <div className='col-sm-6 col-md-4 col-lg-3'>
                {/* <FormInput
                    value={routeName}
                    onChange={handleRouteName}
                    type='select'
                    label='Route'
                    errorText={routeNameError}
                >
                    <option value="">Select</option>
                    {routeMaster.map(rm => {
                        return <Option value={rm.name} key={rm.key}>{rm.name}</Option>
                    })}
                </FormInput> */}
                <FormInput
                    value={routeId}
                    onChange={handleRouteId}
                    type='select'
                    label='Route'
                    labelClassName="required"
                    errorText={routeIdError}
                >
                    <option value="">Select</option>
                    {routeMaster.filter(rm => {
                        return rm.code !== "HIRE"
                    }).map(rm => {
                        return <Option value={rm.id} key={rm.key}>{rm.name}</Option>
                    })}
                </FormInput>

            </div>

            <div className='col-sm-6 col-md-4 col-lg-3'>
                <FormInput
                    label='Stop Number'
                    labelClassName="required"
                    value={number}
                    onChange={handleNumber}
                    placeholder='Number'
                    errorText={numberError}
                    type="number"
                    containerClass="mb-2"
                />
            </div>

            <div className='col-sm-6 col-md-4 col-lg-3'>
                <FormInput
                    label='Stop Name'
                    labelClassName="required"
                    value={name}
                    onChange={handleName}
                    placeholder='Stop Name'
                    errorText={nameError}
                    containerClass="mb-2"
                />
            </div>

        </div>
        <div className="d-flex justify-content-end hstack gap-1">
            <button className="btn btn-primary" onClick={handleClear}>Clear</button>
            <button className="btn btn-success" onClick={handleSave}>Save</button>
        </div>

    </div>
}
export default StopMasterForm